export const STYLES = {
  label: "font-family text-md font-semibold text-gray-05",
  paragraph: "font-family text-sm text-blue-03 font-semibold",
  heading: "font-family font-bold text-gray-05 pl-7 pt-2",
  input:
    "rounded-md border border-solid text-md h-10 w-[200px] border-gray-02 focus:outline-none disabled:bg-transparent",
  checkbox: {
    input: "h-[20px] w-[20px] accent-blue-03",
  },
  table: {
    container: "border border-gray-300 rounded overflow-hidden",
    headerRow: "bg-gray-50",
    headerCell: "px-3 py-2 text-left text-sm font-semibold text-blue-03",
    bodyRow: "border-t border-gray-300",
    bodyCell: "px-3 py-2 h-10 text-blue-03",
    input: "w-full rounded border border-gray-300 px-2 py-1 pr-6 h-8 text-sm",
    percentageSymbol: "absolute right-2 top-1/2 transform -translate-y-1/2 text-sm text-gray-500 pointer-events-none",
    inputWrapper: "relative",
  },
  select: {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#002D5D"
        : state.isFocused
        ? "#002D5D4D"
        : "#FFFFFF",
      transition: "all 0.3s ease",
    }),
    control: (provided, state) => ({
      ...provided,
      boxShadow: "none",
      borderColor: "#C0CBD8",
      outline: "none",
      borderRadius: 6,
      width: "200px",
      marginBottom: "2.5px",
      "&:hover": {
        borderColor: "#C0CBD8",
      },
    }),
    menuPortal: (provided, state) => ({
      ...provided,
      zIndex: 9999,
    }),
  },
};
export const mergeStyles = (baseStyle, overrides = {}) => {
  if (typeof baseStyle === "string") {
    return `${baseStyle} ${overrides}`.trim();
  } else if (typeof baseStyle === "function") {
    return (provided, state) => {
      const baseResult = baseStyle(provided, state);
      const overrideResult =
        typeof overrides === "function"
          ? overrides(provided, state)
          : overrides;
      return { ...baseResult, ...overrideResult };
    };
  }
  return baseStyle;
};
